import useMutation from '@space-shell/common/hooks/useMutation'
import { CommunitiesService } from '@space-shell/common/services/communities'

export type usePutBlockedFollowerParams = {
  communityId: number
  idUser: number
}

export const usePutBlockedFollower = () =>
  useMutation(({ communityId, idUser }: usePutBlockedFollowerParams) =>
    CommunitiesService.putUnBlockUser({ communityId, idUser })
  )
